import { render, staticRenderFns } from "./ThePlantNewCard.vue?vue&type=template&id=79fae76b&scoped=true"
import script from "./ThePlantNewCard.vue?vue&type=script&lang=js"
export * from "./ThePlantNewCard.vue?vue&type=script&lang=js"
import style0 from "./ThePlantNewCard.vue?vue&type=style&index=0&id=79fae76b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fae76b",
  null
  
)

export default component.exports